/* eslint-disable quote-props */
/* eslint-disable react/react-in-jsx-scope */
import { Box, Button, Typography } from "@mui/material";
import { useCallback } from "react";
import { ExternalLinkIcon } from "../../../../../components/Icons";
import { useVetCoveRedirect } from "../../../../../hooks/useVetCoveRedirect";

interface StoreBannerProps {
  title: string;
  description: string;
  buttonText: string;
  imageUrl: string;
  actionUrl: string;
}

const StoreBanner = ({ title, description, buttonText, imageUrl, actionUrl }: StoreBannerProps) => {
  const { handleVetCoveLink } = useVetCoveRedirect();

  const handleClick = useCallback(() => {
    handleVetCoveLink(actionUrl);
  }, [actionUrl, handleVetCoveLink]);

  return (
    <Box className="relative rounded-lg overflow-hidden min-h-[254px]">
      <Box
        className="absolute inset-0 flex flex-col justify-center items-start px-4 sm:px-20"
        sx={{
          backgroundImage: `url('${imageUrl}')`,
          backgroundSize: "cover",
          backgroundPosition: "right center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Box className="max-w-[370px] text-left">
          <Box className="relative inline-block">
            <Typography variant="h1" fontWeight={600} fontSize={40} dangerouslySetInnerHTML={{ __html: title }} />
          </Box>
          <Typography
            pt={1}
            pb={2}
            sx={{
              fontSize: { xs: "13px", sm: "14px" },
            }}
          >
            {description}
          </Typography>
          <Button
            id="access-vetcove-button"
            color="primary"
            sx={{
              fontWeight: 600,
              height: "40px",
              minWidth: "200px",
              paddingX: "32px",
              "& .MuiButton-startIcon": {
                "& svg path": {
                  transition: "fill 0.2s ease",
                },
              },
              "&:hover": {
                "& svg path": {
                  fill: "white",
                },
              },
            }}
            onClick={handleClick}
            startIcon={<ExternalLinkIcon />}
          >
            {buttonText}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default StoreBanner;
